module.exports = __webpack_public_path__ + "9e420b38d564023fd2e066d4f677ee5c.png";